import Vue from "vue";
import { formatInUserZone, userTimeZoneLabel } from "@/utils/datetime";

// Timestamps are rendered in the viewer's own timezone. `moment(value)` was
// used here previously, which reads an offset-less string as browser-local and
// so displayed UTC values unconverted alongside correctly-converted ones. See
// src/utils/datetime.js for the parsing rules.

Vue.filter("changeDateDDMMYYYY", function (value) {
  return formatInUserZone(value, "DD-MM-YYYY h:mm:ss");
});

Vue.filter("changeDateYYYYMMDD", function (value) {
  return formatInUserZone(value, "YYYY-MM-DD h:mm:ss A");
});

Vue.filter("YYYYMMDD", function (value) {
  return formatInUserZone(value, "YYYY-MM-DD");
});

Vue.filter("TIME", function (value) {
  return formatInUserZone(value, "h:mm:ss A");
});

// Same as changeDateYYYYMMDD, with the zone spelled out: "2025-11-06 4:12:29 PM IST".
Vue.filter("changeDateYYYYMMDDTZ", function (value) {
  const formatted = formatInUserZone(value, "YYYY-MM-DD h:mm:ss A");
  if (formatted === "--") return formatted;
  return `${formatted} ${userTimeZoneLabel(value)}`;
});

Vue.filter("amountFormat", function (value, currency) {
  if (value === null || value === undefined || value === "") return "";

  // Custom symbol mapping for African currencies
  const customSymbols = {
    GHS: "₵",
    NGN: "₦",
    XOF: "CFA",
    XAF: "FCFA",
    KES: "KSh",
  };

  try {
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);

    // Replace the currency symbol with custom symbol if available
    if (customSymbols[currency]) {
      // Extract just the number part and prepend custom symbol
      const numberPart = formatted.replace(/[^\d.,]/g, "");
      return customSymbols[currency] + " " + numberPart;
    }

    // Ensure space between currency symbol and amount for standard currencies
    return formatted.replace(/^([^\d.,]+)/, "$1 ").replace(/\s+/g, " ");
  } catch (e) {
    // fallback to plain number format with custom symbol if available
    const numberPart = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);

    if (customSymbols[currency]) {
      return customSymbols[currency] + " " + numberPart;
    }

    return numberPart;
  }
});

Vue.filter("TRIMTEXT", function (value) {
  return value.length > 10 ? value.slice(0, 10) + "..." : value;
});
